import { FormEvent, useState } from 'react'
import { Link } from 'react-router-dom'
import { api, ApiError } from '../../lib/api'
import { trackEvent } from '../../lib/config'
import { SubmitButton } from '../../components/common'
import { AuthAlerts, AuthLayout, AuthLogo, LoginForm } from './AuthLayout'

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [notice, setNotice] = useState<string | null>(null)
  const [errors, setErrors] = useState<string[]>([])
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    if (submitting) {
      return
    }
    setSubmitting(true)
    setErrors([])
    setNotice(null)
    try {
      const result = await api.post<{ notice: string }>('/professionals/password', { professional: { email } })
      trackEvent('Password Reset Requested')
      setNotice(result.notice)
    } catch (requestError) {
      const body = requestError instanceof ApiError ? (requestError.body as { errors?: string[] } | null) : null
      setErrors(body?.errors ?? ['Ocurrió un error, inténtalo nuevamente'])
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <AuthLayout>
      <AuthAlerts notices={notice ? [notice] : []} errors={errors} />
      <LoginForm onSubmit={(event) => void handleSubmit(event)}>
          <AuthLogo />
          <div className="row text-center">
            <p>Si olvidaste tu contraseña, escribe aquí tu email para enviarte las instrucciones.</p>
          </div>
          <div className="form-group col-xs-12">
            <input type="email" className="form-control" placeholder="email" value={email} onChange={(event) => setEmail(event.target.value)} />
            <i className="fa fa-user" />
          </div>
          <div className="form-group col-xs-12">
            <SubmitButton label="Enviar instrucciones" block disabled={submitting} />
          </div>
          <section>
            <Link to="/professionals/sign_in">Iniciar sesión</Link>
            <br />
            <Link to="/professionals/confirmation/new">¿No ha recibido las instrucciones de confirmación?</Link>
            <br />
            <Link to="/professionals/sign_up">¿Quieres una nueva cuenta?</Link>
          </section>
      </LoginForm>
    </AuthLayout>
  )
}
